// ===== Aigent共通モジュール =====

/**
 * metaタグから値を取得するユーティリティ関数
 * @param {string} name - metaタグのname属性
 * @returns {string|null} metaタグのcontent値
 */
export function getMeta(name) {
  return document.head.querySelector(`meta[name='${name}']`)?.content;
}

/**
 * Rails環境をmetaタグから取得
 * @returns {string} Rails環境（development, test, staging, production）
 */
export function getRailsEnv() {
  const railsEnv = getMeta('rails_env');
  console.assert(railsEnv, '[aigent_common.js] Rails.env not identifiable.');
  return railsEnv;
}

/**
 * Rails環境に基づいてSilverEggのドメインを決定
 * @returns {string} SilverEggのドメインURL
 */
export function getSilverEggDomain() {
  const railsEnv = getRailsEnv();
  const merchantId = 'doctorbookac';
  const silverEggDomains = {
    test: `${merchantId}-test.silveregg.net`,
    production: `${merchantId}.silveregg.net`,
  };
  const envDomainMap = {
    test: silverEggDomains.test,
    development: silverEggDomains.test,
    staging: silverEggDomains.test,
    production: silverEggDomains.production,
  };
  return envDomainMap[railsEnv];
}

/**
 * Aigent Cookie IDをmetaタグから取得
 * @returns {string} Aigent Cookie ID
 */
export function getAigentCookieId() {
  const id = getMeta('aigent_cookie_id');
  console.assert(id, '[aigent_common.js] the aigent id not identifiable.');
  return id;
}

// correlations: 相関種別
export const correlationTypes = {
  // 閲覧閲覧(BB)相関: このアイテムを見ている人は、こんなアイテムも見ています
  BrowseBrowse: 'BB',
  // 過去購買(PO)相関: このアイテムを購入(CV)した人は、次にこんなアイテムを購入(CV)しています
  PurchaseOrder: 'PO',
};

export const pageKinds = {
  top: 'top',                 // トップページ
  movieDetail: 'movieDetail', // 動画詳細ページ
  my: 'my',                   // マイページ
};

// identify the kind of source page
export function determinePageKind() {
  const path = location.pathname;
  if (path == '/') {
    return pageKinds.top;
  } else if (path.startsWith('/mypage')) {
    return pageKinds.my;
  } else if (path.match(/^\/movies\/[0-9]+\/?$/)) {
    return pageKinds.movieDetail;
  } else {
    console.warn(`[aigent_common.js] Excluded pageKind. path: ${path}`);
    return null;
  }
};

export function determinePlatformKind(smartphoneMaxWidth = 667) {
  const platformKinds = { pc: 'pc', smartphone: 'sp'};  // PC, SmartPhone
  const isSmartphone = (window.innerWidth <= smartphoneMaxWidth);

  return isSmartphone ? platformKinds.smartphone : platformKinds.pc;
}

// specId: [ページ種別, 相関種別, platform種別(pc/sp)]毎に定義されている
export function determineSpecId(platformKind, pageKind, correlationType) {
  const condition = `${platformKind}_${pageKind}_${correlationType}`;
  const specIds = {
    'pc_top_BB': 'pc111',
    'pc_top_PO': 'pc112',
    'pc_movieDetail_BB': 'pc311',
    'pc_movieDetail_PO': 'pc312',
    'pc_my_BB': 'pc611',
    'pc_my_PO': 'pc612',
    'sp_top_BB': 'sp111',
    'sp_top_PO': 'sp112',
    'sp_movieDetail_BB': 'sp311',
    'sp_movieDetail_PO': 'sp312',
    'sp_my_BB': 'sp611',
    'sp_my_PO': 'sp612',
  };

  return specIds[condition];
}
